<template>
  <div id="briefIntroduction" style="min-height:700px">
    <div class="bread">
      <img src="../images/icon/routerbg.png" alt="">
      <div>
        <router-link to="/"><span class="home">EDG首页</span></router-link>
        <img src="../images/icon/arrow_right.png"/>
        <span>EDG简介</span>
      </div>
    </div>
    <div style="margin: 0 auto;min-height: 560px;width: 1150px;position: relative">
      <div style="width: 610px;min-height: 560px;" v-html="thedata.text">
      </div>
      <img :src="thedata.imageUrl" alt=""
           style="width: 458px;height: 549px;position: absolute;right: 0px;top: 0px;border-style:none; "
           :class="{ showboder: ifshowboder}">
    </div>
  </div>
</template>

<script>
  var _this;
  export default {
    name: 'briefIntroduction',
    data() {
      return {
        msg: '首页',
        thedata: '',
        ifshowboder: true,
      }
    },
    //监听
    watch: {},

    //事件处理
    methods: {
      //    获取数据
      requestEDGIntro: function (offset) {
        this.request.get({
          url: '/about/text/1',
          params: {},
          callback: function (data) {
            console.log(data)
            // if(data.data.length==0) return;
            if (data.data.imageUrl != '') {
              _this.ifshowboder = false;
            }
            _this.thedata = data.data;
          }.bind(this)
        })
      },
    },

    //实例加载完成后
    created() {
    },

    //页面完成以后
    mounted: function () {
      _this = this;
      //获取EDG
      this.requestEDGIntro();
    },
  }
</script>

<style scoped>
  #briefIntroduction {
    background: url(../images/bg.png);
  }

  .bread {
    position: relative;
    margin-top: 20px;
    margin-left: 15%;
    height: 36px;
    width: 290px;
    line-height: 36px;
    /*background-image: url("../images/icon/routerbg.png");*/
    background-size: cover;
    font-size: 24px;
  }

  .bread > img {
    height: 36px;
    width: 290px;
  }

  .bread > div {
    position: absolute;
    top: 0;
    left: 0;
  }

  .bread div span {
    margin-left: 5px;
    display: inline-block;
    vertical-align: middle;
  }

  .bread div img {
    display: inline-block;
    vertical-align: middle;
  }

  .showboder {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/briefIntroduction.vue